import { STATE } from "./camera/orbit-controls-extended";
import Utils from "./utils";
import RenderManager from "./rendering/render-manager";

const Analytics = new class Analytics {
    constructor() {
        this.rotateStart = null;
        this.panStart = null;
        this.dollyStart = null;
        this.sessionID = Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2);
        this.highlightObj = null;
        this.interval = null;
        this.tourStarted = false;
        this.isFinished = false;
        this.idleTime = 0;
        this.actions = [];
        this.windowBlur = null;
        this.objects2D = []; //objects onj current slide;
        this.interactives = {}; //Buttons, Sliders
        this.mouseStart = null;
        this.mouseEnd = null;
        this.totalVisibleSlides = 0;
        this.adBlocker = null;
        window.COOBO && this.isAdBlock();
    }

    isAdBlock(){
        fetch('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js',{
            method: 'HEAD',
            mode: 'no-cors'
        }).then(
            () => {this.adBlocker = false},
            () => {this.adBlocker = true}
        );
    }
    start() {
        if (Q3.editMode || this.adBlocker === true) return;
        this.sessionID = Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2);
        this.tourStarted = this.getTimestamp();
        this.switchSlide(0);
        Window.COOBO && analytics.identify(this.sessionID, this.initialData);
        this.totalVisibleSlides = Q3.SlideManager.visibleSlideCount;
        this.add({
            type: "tour-start",
            slide: Q3.SlideManager.activeSlide,
            slideUuid: Q3.data.slides[Q3.SlideManager.activeSlide].uuid,
            loadingTime: this.loadingTime,
            timeToInteraction: this.timeToInteraction,
            tourMeta: Q3.data.meta,
            quizzes: Q3.data.slides.reduce((acc, s, i) => {
                if (s.slideQuiz && s.slideQuiz.active)
                    acc.push({ slide: i + 1, type: s.slideQuiz.type });
                return acc;
            }, []),
            interactives: Q3.data.slides.reduce((acc, s, i) => {
                Object.keys(s.layers2D).forEach((lUuid) => {
                    let layer = Q3.data.layers.layers2D[lUuid];
                    if (layer && layer.objects) {
                        let objUuid = Object.keys(layer.objects)[0];
                        if (objUuid && ["button", "slider"].indexOf(layer.objects[objUuid].type) !== -1) {
                            acc.push({ slide: i + 1, uuid: objUuid, type: layer.objects[objUuid].type })
                        }
                    }
                });
                return acc;
            }, []),
            // slideMeta: Q3.CGMeta[Q3.SlideManager.currentSlide.uuid]
        });
        this.initMouseLogging();
        this.initClickLogging();
        window.addEventListener('focus', () => {
            if (this.windowBlur) {
                let idleTime = (new Date().getTime()) - this.windowBlur;
                this.idleTime += idleTime;
            }
        });

        window.addEventListener('blur', () => {
            if (this.mouseStart) {
                clearTimeout(this.mouseTimeout);
                this.pushMouseLog();
            }
            this.windowBlur = new Date().getTime();

        });

    }

    moveHandler(e) {
        if (!this.mouseStart) {
            this.mouseStart = this.getTimestamp();
        } else {
            this.mouseEnd = this.getTimestamp();
            clearTimeout(this.mouseTimeout);
            this.mouseTimeout = setTimeout(() => {
                this.pushMouseLog();
            }, 3000)
        }
    }

    pushMouseLog() {
        this.add({ type: "mouselog", start: this.mouseStart, end: this.mouseEnd });
        this.mouseStart = null;
    }

    initMouseLogging() {
        this.moveHandler = this.moveHandler.bind(this);
        document.addEventListener("mousemove", this.moveHandler)
    }

    filter2DObjects() {
        this.objects2D = Object.values(Q3.layers.list)
            .reduce((acc, val) => {
                if (val.objects
                    && val.objects[0]
                    // && ["Video", "Spline", "Line"].indexOf(val.objects[0].type2d) === -1
                ) {
                    acc.push(val.objects[0]);
                }
                return acc;
            }, []);
        this.interactives = this.objects2D.reduce((acc, obj) => {
            if (obj.type2d === "Button" || obj.type2d === "Slider") {
                acc[obj.uuid] = {
                    type: obj.type2d,
                    uuid: obj.uuid,
                    interactions: 0
                }
            }
            return acc;
        }, {})
    }

    checkObj(obj, click) {
        if (!obj.x || !obj.y || !obj.width || !obj.height) return false;

        const width = Q3.letterbox.offsetWidth;
        const height = Q3.letterbox.offsetHeight;

        const w = obj.width * width;
        const h = obj.height * height;
        const x = obj.x * width + Q3.letterbox.offsetLeft;
        const y = obj.y * height + Q3.letterbox.offsetTop;

        return (click.x >= x && click.x <= x + w && click.y >= y && click.y <= y + h)
    }

    checkEventTarget(e) {
        let clicked = false;
        if (e.target !== RenderManager.overlay2d) {
            for (let i = 0; i < this.objects2D.length; i++) {
                let obj = this.objects2D[i];
                if (obj.domElement && obj.domElement.contains(e.target)) {
                    clicked = obj;
                    break;
                }
            }
        } else {
            for (let i = 0; i < this.objects2D.length; i++) {
                let obj = this.objects2D[i];
                if (this.checkObj(obj, { x: e.clientX, y: e.clientY })) {
                    clicked = obj;
                    break;
                }
            }
        }
        return clicked;
    }

    clickHandler(e) {
        let clicked = this.checkEventTarget(e);
        if (clicked) {
            this.add({ type: "click", targetType: clicked.type2d, targetId: clicked.parentLayer.uuid, targetName: clicked.parentLayer.name })
        }
    }

    mouseDownhandler(e) {
        let clicked = this.checkEventTarget(e);
        if (clicked) {
            if (this.interactives[clicked.uuid]) {
                this.interactives[clicked.uuid].interactions++;
            }
        }
    }

    initClickLogging() {
        this.clickHandler = this.clickHandler.bind(this);
        this.mouseDownhandler = this.mouseDownhandler.bind(this);
        document.addEventListener("click", this.clickHandler, true)
        document.addEventListener("mousedown", this.mouseDownhandler, true)
    }

    reset() {
        this.add({ type: "restart" });
    }

    switchSlide(slide, opts = {}) {
        if (!this.tourStarted) return;
        let switchedFrom = Q3.SlideManager.prevSlide;
        if (switchedFrom !== null && switchedFrom !== slide) {
            let data = {
                type: "slide-switch",
                userAction: Boolean(opts.userAction),
                from: switchedFrom + 1,
                fromUuid: Q3.data.slides[switchedFrom].uuid,
                to: slide + 1,
                toUuid: Q3.data.slides[slide].uuid,
                // toSlideMeta: Q3.CGMeta[Q3.data.slides[slide].uuid],
            };
            let skippedInteractives = Object.values(this.interactives).filter(i => i.interactions === 0).map(i => { return { type: i.type, uuid: i.uuid } });
            if (skippedInteractives.length) {
                data.skippedInteractives = skippedInteractives;
            }
            this.add(data)
        }
        this.filter2DObjects();
    }

    add(data) {
        if (Q3.editMode || !this.tourStarted || this.isFinished || this.adBlocker === true) return;
        let timestamp = this.getTimestamp();
        let action = Object.assign({
            tourId: Q3.data._id,
            totalSlideCount: Q3.SlideManager.slideCount,
            totalHiddenSlides: Q3.SlideManager.slideCount - Q3.SlideManager.visibleSlideCount,
            slide: Q3.SlideManager.activeSlide + 1,
            slideUuid: Q3.data.slides[Q3.SlideManager.activeSlide].uuid,
            timestamp: timestamp,
        }, data);
        this.actions.push(action);
        Window.COOBO && analytics.track(data.type, action);
    }

    addCameraInteraction(value) {
        switch (value) {

            case STATE.ROTATE:
            case STATE.TOUCH_ROTATE:
                // this.add({type: "camera-rotate", text: `Camera rotated from: "${this.rotateStart.toArray()}" to "${Q3.camera.quaternion.toArray()}"`});
                this.add({ type: "camera-rotate" });
                break;

            case STATE.TOUCH_DOLLY:
            case STATE.DOLLY:
                // this.add({type: "camera-zoom", text: `Camera zoomed from: "${this.dollyStart.toArray()}" to "${Q3.camera.position.toArray()}"`});
                this.add({ type: "camera-zoom" });
                break;

            case STATE.TOUCH_PAN:
            case STATE.PAN:
                // this.add({type: "camera-pan", text: `Camera move from: "${this.panStart.toArray()}" to "${Q3.camera.position.toArray()}"`});
                this.add({ type: "camera-pan" });
                break;

        }
    }

    addHighlight(obj) {
        if (obj && obj !== this.highlightObj) {
            let data = { type: "highlight", object: obj.name };
            let meshLabels = Q3.labels.live._meshLabels[obj.id];
            if (meshLabels && meshLabels._labels[0] && meshLabels._labels[0].meta) {
                data.meta = meshLabels._labels[0].meta;
            } else if (obj.refId) {
                data.assetId = obj.refId;
                let asset = Q3.AssetDeserializer.references[obj.refId];
                if (asset.meta) {
                    data.meta = asset.meta;
                }
            }
            this.add(data)
        }
    }

    getTimeSpent() {
        return this.getTimestamp() - this.tourStarted;
    }

    getTimestamp() {
        return (new Date().getTime()) - this.idleTime;
    }

    finishTour(results) {
        let data = { type: "finish" };
        let skippedInteractives = Object.values(this.interactives).filter(i => i.interactions === 0).map(i => { return { type: i.type, uuid: i.uuid } });
        if (skippedInteractives.length) {
            data.skippedInteractives = skippedInteractives;
        }
        this.add(data);
        this.isFinished = true;
    }

    get initialData() {
        var gl = RenderManager.mainRenderer.domElement.getContext("experimental-webgl");
        let data = {
            GPU: getUnmaskedInfo(gl).renderer,
            userAgent: navigator.userAgent,
            screenSize: {
                width: window.innerWidth,
                height: window.innerHeight
            },
            tourID: Q3.data._id,
            sessionID: this.sessionID,
            tourStarted: this.tourStarted,
            loadingTime: this.loadingTime
        };
        let queryparams = Utils.getQueryParams().values;
        Object.keys(queryparams).forEach((p) => {
            let val = queryparams[p];
            if (val) {
                data[p] = val;
            }
        });
        return data;
    }
};


export default Analytics;
export { Analytics };

function getUnmaskedInfo(gl) {
    const unMaskedInfo = {
        renderer: '',
        vendor: ''
    };

    const dbgRenderInfo = gl.getExtension("WEBGL_debug_renderer_info");
    if (dbgRenderInfo != null) {
        unMaskedInfo.renderer = gl.getParameter(dbgRenderInfo.UNMASKED_RENDERER_WEBGL);
        unMaskedInfo.vendor = gl.getParameter(dbgRenderInfo.UNMASKED_VENDOR_WEBGL);
    }

    return unMaskedInfo;
}
